import React, { useContext } from 'react'

import FormatCurrency from 'components/Common/FormatCurrency'
import Pill from 'components/Luxkit/Pill'

import Caption from 'components/Luxkit/Typography/Caption'
import GeoContext from 'contexts/geoContext'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import isUltraLuxTour from 'lib/TourV2/isUltraLuxTour'
import PrimaryButtonPaletteProvider, { PrimaryButtonPalette } from 'contexts/PrimaryButtonPaletteProvider'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  tour: Tours.V2Offer | Tours.V2OfferSummary;
  className?: string;
}

function TourTilePricing(props: Props) {
  const { tour } = props
  const { showTaxExclusivePrices } = useContext(GeoContext)

  const {
    cheapestPurchasableOption,
  } = useCheapestOfTourV2Offer(tour)

  const {
    pricePerPerson,
    roomTypeName,
    valuedAt,
    hasDiscount,
    fullPricePerPerson,
  } = useTourV2PurchasableOptionDetails(cheapestPurchasableOption)

  const isUltraLux = isUltraLuxTour(tour)
  let paletteValue: PrimaryButtonPalette
  if (isUltraLux) {
    paletteValue = 'ultralux'
  } else {
    paletteValue = 'default'
  }

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical">
        <Caption variant="medium" colour="neutral-three">From</Caption>
        <BodyText variant="large" weight="semi-bold">
          <FormatCurrency value={pricePerPerson} format="roundedDollar" />
          <Caption variant="medium" as="span" colour="neutral-two" weight="normal">/person</Caption>
        </BodyText>
        {hasDiscount && <Caption variant="large" colour="neutral-three"><s>Was: <FormatCurrency value={fullPricePerPerson} format="roundedDollar" /></s></Caption>}
        {valuedAt &&
          <BodyText variant="small" weight="semi-bold" colour="neutral-one">
            <Group direction="horizontal" verticalAlign="center" gap={4}>
              <span data-testid="value-box">
                Valued up to <FormatCurrency value={Math.ceil(valuedAt.price)} />
              </span>
              <Pill kind="primary" variant="success">-{valuedAt.savingPercentage}%</Pill>
            </Group>
          </BodyText>
          }
        <BodyText as="span" variant="small" colour={showTaxExclusivePrices ? 'highlight' : 'neutral-three'}>Includes taxes & fees</BodyText>
        <BodyText as="span" variant="small" colour="neutral-three">{roomTypeName}</BodyText>
      </Group>
      <PrimaryButtonPaletteProvider palette={paletteValue}>
        <TextButton kind="primary" size="small">View</TextButton>
      </PrimaryButtonPaletteProvider>
    </Group>
  )
}

export default TourTilePricing
